import type { TableFilterState, TableSortingState } from '@ibsys/kit';
import type { TableSearchState } from '../types';

/** Суффиксы ключей URL-параметров состояния таблицы */
export const PARAM_KEYS = {
  filters: 'filters',
  sorting: 'sorting',
  offset: 'offset',
  search: 'search',
  searchMode: 'searchMode',
} as const;

/** Возвращает имя URL-параметра с префиксом таблицы */
export function paramKey(name: string, key: keyof typeof PARAM_KEYS): string {
  return `${name}_${PARAM_KEYS[key]}`;
}

/** Десериализует фильтры из строки URL-параметра; при ошибке возвращает `[]` */
export function parseFilters(value: string | null): TableFilterState {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value) as unknown;
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** Десериализует сортировку из строки URL-параметра; при ошибке возвращает `[]` */
export function parseSorting(value: string | null): TableSortingState {
  if (!value) return [];
  try {
    const parsed = JSON.parse(value) as unknown;
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/** Парсит offset из строки URL-параметра; отрицательные и NaN значения возвращают `undefined` */
export function parseOffset(value: string | null): number | undefined {
  if (value === null || value === '') return undefined;
  const n = Number.parseInt(value, 10);
  return Number.isNaN(n) || n < 0 ? undefined : n;
}

/** Собирает `TableSearchState` из двух URL-параметров; при отсутствии запроса возвращает `undefined` */
export function parseSearch(query: string | null, mode: string | null): TableSearchState | undefined {
  if (!query) return undefined;
  return { query, mode: mode === 'dsl' ? 'dsl' : 'nl' };
}
